module.exports = __webpack_public_path__ + "img/aland-islands.32761e56.svg";